import { ComboboxItem } from "@mantine/core"

import { LanguageIso6391 } from "@tfg/types/constants/language.constants"
import { LibraryResponses } from "@tfg/types/endpoints/library"

import { MaterialTypesResponseDto } from "~/gen/api"

export function formatMaterialTypeSelectOptions(
  materialTypes: MaterialTypesResponseDto[],
  selectedMaterialTypeId: number,
  language: string
): ComboboxItem[] {
  if (!materialTypes) return []
  return materialTypes
    .filter((item) => !item.deletedAt)
    .map((materialType) => {
      const label: string =
        (language === LanguageIso6391.EN || language === LanguageIso6391.FR) &&
        materialType[language]
          ? materialType[language]
          : materialType.key

      return {
        key: materialType.id.toString(),
        value: materialType.id.toString(),
        disabled: materialType.id === selectedMaterialTypeId,
        label,
      }
    })
    .sort((a, b) => a.label.localeCompare(b.label))
}

export function getCustomFieldDefinitions(
  product: LibraryResponses.ProductDetails,
  component: LibraryResponses.EnrichedComponent
): LibraryResponses.ProductDetails["customFieldDefinitions"] {
  return product.customFieldDefinitions.filter(
    (cfd) =>
      component.item.operations.some(
        (o) => o.activityId === cfd.forActivityId
      ) &&
      (!cfd.onActivityId ||
        product.item.operations.some((o) => o.activityId === cfd.onActivityId))
  )
}
